import React from "react";
import { Link } from "react-router-dom";
import { Mail, Phone, MapPin, Facebook, Instagram, Twitter, Linkedin, ShieldCheck, Award, CheckCircle2 } from "lucide-react";
import Logo from "@/components/Logo";

export default function PublicFooter({ contact }) {
  return (
    <footer className="mt-0">
      {/* Registration badges strip */}
      <div className="bg-[#0B1120] border-t-4 border-[#F59E0B] py-6">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 grid sm:grid-cols-3 gap-4 text-white text-sm">
          <div className="flex items-center justify-center gap-2"><CheckCircle2 size={16} className="text-emerald-400" /> 80G Registration: <b>AAOCP5008QF20251</b></div>
          <div className="flex items-center justify-center gap-2"><ShieldCheck size={16} className="text-brand" /> NGO Darpan: <b>BR/2024/0396082</b></div>
          <div className="flex items-center justify-center gap-2"><Award size={16} className="text-[#F59E0B]" /> CIN: <b>U84120BR2024NPL067860</b></div>
        </div>
      </div>

      {/* Main footer */}
      <div className="bg-brand text-blue-100">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
          <div>
            <Logo size={52} textClassName="text-white" />
            <p className="mt-4 text-sm leading-relaxed">
              PMR Welfare Foundation is a non-profit organization focused on social welfare activities including education, healthcare, food distribution, women empowerment, and rural development.
            </p>
            <div className="flex gap-3 mt-5">
              <a className="w-9 h-9 rounded-full bg-white/10 hover:bg-[#F59E0B] flex items-center justify-center transition-colors" href="#" aria-label="Facebook"><Facebook size={16} /></a>
              <a className="w-9 h-9 rounded-full bg-white/10 hover:bg-[#F59E0B] flex items-center justify-center transition-colors" href="#" aria-label="Instagram"><Instagram size={16} /></a>
              <a className="w-9 h-9 rounded-full bg-white/10 hover:bg-[#F59E0B] flex items-center justify-center transition-colors" href="#" aria-label="LinkedIn"><Linkedin size={16} /></a>
              <a className="w-9 h-9 rounded-full bg-white/10 hover:bg-[#F59E0B] flex items-center justify-center transition-colors" href="#" aria-label="Twitter"><Twitter size={16} /></a>
            </div>
          </div>

          <div>
            <div className="text-xs font-black uppercase tracking-[0.2em] text-white mb-4">Quick Links</div>
            <ul className="space-y-2.5 text-sm">
              <li><Link to="/about" className="hover:text-[#F59E0B]">About Us</Link></li>
              <li><Link to="/programs" className="hover:text-[#F59E0B]">Programs</Link></li>
              <li><Link to="/donate" className="hover:text-[#F59E0B]">Donate</Link></li>
              <li><Link to="/register" className="hover:text-[#F59E0B]">Volunteer</Link></li>
              <li><Link to="/gallery" className="hover:text-[#F59E0B]">Gallery</Link></li>
              <li><Link to="/contact" className="hover:text-[#F59E0B]">Contact</Link></li>
              <li><Link to="/verify" className="hover:text-[#F59E0B]">Verify Certificate</Link></li>
              <li><Link to="/login" className="hover:text-[#F59E0B] font-bold text-amber-300">Member Login</Link></li>
            </ul>
          </div>

          <div>
            <div className="text-xs font-black uppercase tracking-[0.2em] text-white mb-4">Legal Information</div>
            <ul className="space-y-2.5 text-sm">
              <li><Link to="/privacy" className="hover:text-[#F59E0B]">Privacy Policy</Link></li>
              <li><Link to="/terms" className="hover:text-[#F59E0B]">Terms &amp; Conditions</Link></li>
              <li><Link to="/refund" className="hover:text-[#F59E0B]">Refund Policy</Link></li>
            </ul>
            <div className="mt-5 text-xs font-black uppercase tracking-[0.2em] text-white mb-3">Registration Details</div>
            <div className="text-xs space-y-1.5">
              <div>80G Registration: <b>AAOCP5008QF20251</b></div>
              <div>NGO Darpan ID: <b>BR/2024/0396082</b></div>
              <div>Section 8 Company</div>
              <div>CIN: <b>U84120BR2024NPL067860</b></div>
            </div>
          </div>

          <div>
            <div className="text-xs font-black uppercase tracking-[0.2em] text-white mb-4">Contact</div>
            <div className="flex items-start gap-2 text-sm mb-4">
              <MapPin size={14} className="mt-0.5 shrink-0 text-[#F59E0B]" />
              <div>
                <div>PMR WELFARE FOUNDATION,</div>
                <div>Ram Shyam Niketan apartment,</div>
                <div>Nehru Nagar Rd, near Patliputra Police station,</div>
                <div>{contact?.contact_address || "Patna, Bihar 800001"}</div>
              </div>
            </div>
            <a href={`tel:${contact?.contact_phone || '+91 9155561892'}`} className="flex items-center gap-2 text-sm hover:text-[#F59E0B]">
              <Phone size={14} className="text-[#F59E0B]" /> {contact?.contact_phone || "+91 9155561892"}
            </a>
            <a href={`mailto:${contact?.contact_email || 'contact@pmrwelfarefoundation.in'}`} className="mt-2 flex items-center gap-2 text-sm hover:text-[#F59E0B] break-all">
              <Mail size={14} className="text-[#F59E0B] shrink-0" /> {contact?.contact_email || "contact@pmrwelfarefoundation.in"}
            </a>
          </div>
        </div>

        <div className="border-t border-white/10">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-5 flex flex-col sm:flex-row items-center justify-between gap-2 text-xs text-blue-200">
            <div>© {new Date().getFullYear()} PMR Welfare Foundation. All rights reserved.</div>
            <div className="font-semibold">
              Project crafted by <span className="text-[#F59E0B] font-black">Sonal Singh &amp; Team</span>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
